import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { SolutionPageStructuredData } from "../../config/StructuredData";

const AdvocatesPage = () => (
  <>
    <SolutionPageStructuredData
      name="Workflow Management for Advocates and Litigation Teams"
      description="Simplifyte helps advocates and litigation teams organise case files, track court dates, manage client communication, approvals and closure proof in one structured workspace."
      url="https://www.simplifyte.com/solutions/advocates"
    />
    <HeaderMenu />

    <main style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <section style={{ background: "linear-gradient(135deg,#093A5B 0%,#0a4d6e 100%)", padding: "60px 24px", color: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto" }}>
          <p style={{ fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.7, marginBottom: "16px" }}>Solutions / Advocates</p>
          <h1 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 700, lineHeight: 1.2, marginBottom: "20px" }}>
            Workflow Management for Advocates and Litigation Teams
          </h1>
          <p style={{ fontSize: "18px", opacity: 0.85, maxWidth: "700px", margin: "0 auto 32px" }}>
            Simplifyte helps advocates and legal teams manage case files, hearing dates, client communication, document collection, approvals and closure proof — in one structured workspace that replaces scattered notes and WhatsApp threads.
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>Book a Demo</Link>
            <Link to="/pricing" style={{ border: "1px solid rgba(255,255,255,0.5)", color: "#fff", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>View Pricing</Link>
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px" }}>
        <div style={{ maxWidth: "860px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "28px", fontWeight: 700, color: "#093A5B", marginBottom: "24px" }}>What advocates manage with Simplifyte</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: "20px" }}>
            {[
              { title: "Case file organisation", desc: "Every brief, petition, contract, and evidence file organised by matter and client — not scattered across email and drives." },
              { title: "Hearing and deadline tracking", desc: "Track court dates, filing deadlines, and limitation periods with automated reminders to the right team member." },
              { title: "Client communication log", desc: "Every client conversation, instruction, and update is logged in one searchable timeline — no more lost WhatsApp threads." },
              { title: "Document collection", desc: "Track which supporting documents are pending from clients with structured follow-up reminders." },
              { title: "Review and approval", desc: "Drafts go through a structured review process before they reach the client or court — with a complete revision history." },
              { title: "Matter closure proof", desc: "Generate timestamped closure records for every completed matter — for your files and your client's records." },
            ].map((f, i) => (
              <div key={i} style={{ background: "#f8fafc", padding: "20px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
                <CheckCircle2 size={22} color="#093A5B" style={{ marginBottom: "10px" }} />
                <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#1e293b", marginBottom: "8px" }}>{f.title}</h3>
                <p style={{ fontSize: "14px", color: "#64748b", lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px", textAlign: "center", background: "#093A5B", color: "#fff" }}>
        <h2 style={{ fontSize: "28px", fontWeight: 700, marginBottom: "16px" }}>Bring structure to your legal practice</h2>
        <p style={{ opacity: 0.8, marginBottom: "28px", fontSize: "16px" }}>See how Simplifyte helps advocates manage matters, deadlines, and client work without chaos.</p>
        <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "14px 32px", borderRadius: "8px", fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}>
          Book a Demo <ArrowRight size={16} />
        </Link>
      </section>
    </main>

    <CustomFooter />
  </>
);

export default AdvocatesPage;
